import { Link } from "react-router-dom";
import { cld, money, CATEGORY_LABEL, dims } from "@/lib/api";

export const ArtworkCard = ({ p, index = 0 }) => (
  <Link
    to={`/artwork/${p.slug}`}
    data-testid={`gallery-card-${p.slug}`}
    className="fade-up group block"
    style={{ animationDelay: `${Math.min(index, 8) * 90}ms` }}
  >
    <div className="relative aspect-[4/5] overflow-hidden bg-[#F2EEE6]">
      <img
        src={cld(p.images?.[0], "w_900,q_auto,f_auto")}
        alt={p.title}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.035]"
      />
      {p.isSold && (
        <span data-testid={`gallery-sold-badge-${p.slug}`} className="absolute left-5 top-5 bg-[#1A1A1A] px-3 py-1.5 text-[10px] tracking-[0.3em] text-[#FDFBF7]">
          SOLD
        </span>
      )}
    </div>
    <div className="mt-6 flex items-start justify-between gap-6">
      <div>
        <h3 className="font-display text-2xl font-normal leading-tight">{p.title}</h3>
        <p className="mt-2 text-[11px] uppercase tracking-[0.2em] text-[#8C7A5B]">{CATEGORY_LABEL[p.category]}</p>
        {p.isOriginal && <p className="mt-1 text-xs text-[#5A626A]">{dims(p)}</p>}
      </div>
      <p className="whitespace-nowrap pt-1 text-sm text-[#5A626A]" data-testid={`gallery-price-${p.slug}`}>
        {p.isSold ? "Sold" : p.isOriginal ? money(p.price) : `From ${money(p.price)}`}
      </p>
    </div>
  </Link>
);
